import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ProjectLineAddToCartState from "@tSurya/Store/Data/ProjectLineAddToCartState";
import { Draft } from "immer";

const initialState: ProjectLineAddToCartState = {
    activeRequestCount: 0,
};

const reducer = {
    "Pages/MyListsDetails/BeginProjectLineAddToCart": (draft: Draft<ProjectLineAddToCartState>) => {
        draft.activeRequestCount += 1;
    },
    "Pages/MyListsDetails/CompleteProjectLineAddToCart": (draft: Draft<ProjectLineAddToCartState>) => {
        draft.activeRequestCount = Math.max(0, draft.activeRequestCount - 1);
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
